import { render, staticRenderFns } from "./NewExternal.vue?vue&type=template&id=82aaba6a&scoped=true"
import script from "./NewExternal.vue?vue&type=script&lang=js"
export * from "./NewExternal.vue?vue&type=script&lang=js"
import style0 from "./NewExternal.vue?vue&type=style&index=0&id=82aaba6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82aaba6a",
  null
  
)

export default component.exports